import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Styles.css";
import { useNavigate } from "react-router-dom";
import React, { useState, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import {
  FaLinkedin,
  FaTwitter,
  FaGithub,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

import logo from "../assets/logo24.png";
import { Link } from "react-router-dom";

const ReachUs = () => {
  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    // Close mobile navbar after click
    const navLinks = document.getElementById("navLinks");
    if (navLinks.classList.contains("show")) {
      const navbarToggler = document.querySelector(".navbar-toggler");
      navbarToggler.click();
    }
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");
  const navigate = useNavigate();

  const aboutRef = useRef(null);
  const getInTouchRef = useRef(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const response = await fetch(
        "https://guftagu-landing-service-backend-576610474197.asia-south1.run.app/contact/reachus/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setStatus("Message sent successfully!");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        const errorData = await response.json();
        console.error("Error:", errorData);
        setStatus("Failed to send message.");
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus("An error occurred while sending.");
    }
  };

  return (
    <>
      {/* HEADER */}
            <Header
              sectionsRef={{
                about: aboutRef,
                getInTouch: getInTouchRef
              }}
            />
          {/* main data */}
          <div className="contact-hero">

  {/* LEFT */}
  <div className="contact-left">

    <p className="contact-tag">
      LET’S BUILD SOMETHING AMAZING
    </p>

    <h1 className="contact-title">
      Get in <span>Touch</span>
    </h1>

    <p className="contact-subtitle">
      We’d love to hear from you. Whether you have a
      question, idea, partnership, or just want to say hello —
      our team is ready.
    </p>

    <div className="contact-info">

      <div className="info-card">
        <FaEnvelope className="info-icon" />
        <div>
          <h5>Email</h5>
          <p>info@neomonkstech.com</p>
        </div>
      </div>

      <div className="info-card">
        <FaPhoneAlt className="info-icon" />
        <div>
          <h5>Phone</h5>
          <p>+91 99103 57690</p>
        </div>
      </div>

      <div className="info-card">
        <FaMapMarkerAlt className="info-icon" />
        <div>
          <h5>Location</h5>
          <p>Delhi, India</p>
        </div>
      </div>

    </div>
  </div>

  {/* RIGHT */}
  <div className="contact-right">

    <form className="contact-form" onSubmit={handleSubmit}>

      <input
        type="text"
        name="name"
        placeholder="Your Name"
        value={formData.name}
        onChange={handleChange}
        required
      />

      <input
        type="email"
        name="email"
        placeholder="Your Email"
        value={formData.email}
        onChange={handleChange}
        required
      />

      <input
        type="text"
        name="subject"
        placeholder="Subject"
        value={formData.subject}
        onChange={handleChange}
      />

      <textarea
        name="message"
        rows="5"
        placeholder="Your Message"
        value={formData.message}
        onChange={handleChange}
        required
      />

      <button type="submit" className="send-btn">
        Send Message
      </button>

      {status && (
        <p className="status-text">{status}</p>
      )}

    </form>

  </div>

</div>
          {/* FOOTER */}
                <Footer
                  sectionsRef={{
                    about: aboutRef,
                    getInTouch: getInTouchRef
                  }}
                />
    </>
  );
};

export default ReachUs;
